import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill="#F3F5FC" />
    <G clipPath="url(#clip0_997_6725)">
      <Rect
        x={11.3647}
        y={18.5199}
        width={9.3341}
        height={16.3347}
        transform="rotate(-42.5572 11.3647 18.5199)"
        fill="#C6D4FF"
      />
      <Path
        opacity={0.2}
        d="M18.8478 19.6993C19.7917 18.8327 21.2594 18.8953 22.126 19.8392C22.9927 20.7831 22.93 22.2508 21.9862 23.1174C21.0423 23.9841 19.5746 23.9214 18.7079 22.9776C17.8413 22.0337 17.9039 20.566 18.8478 19.6993Z"
        fill="black"
        stroke="#1434CB"
        strokeWidth={0.073656}
      />
      <Path
        opacity={0.2}
        d="M14.0735 18.6355C14.0427 19.3592 13.7919 20.0559 13.3551 20.633L11.4171 18.5222L13.5279 16.5842C13.9139 17.1963 14.1044 17.9118 14.0735 18.6355Z"
        fill="#A7BBF7"
        stroke="#1434CB"
        strokeWidth={0.073656}
      />
      <Path
        opacity={0.2}
        d="M18.1944 14.8522C17.4707 14.8213 16.7739 14.5705 16.1969 14.1338L18.3077 12.1957L20.2457 14.3065C19.6336 14.6925 18.9181 14.8831 18.1944 14.8522Z"
        fill="#A7BBF7"
        stroke="#1434CB"
        strokeWidth={0.073656}
      />
      <Path
        opacity={0.2}
        d="M29.416 24.2945L27.3053 26.2325C26.9192 25.6204 26.7287 24.9048 26.7596 24.1811C26.7904 23.4574 27.0412 22.7607 27.478 22.1837L29.416 24.2945Z"
        fill="#A7BBF7"
        stroke="#1434CB"
        strokeWidth={0.073656}
      />
      <Path
        opacity={0.2}
        d="M22.639 27.9646C23.3627 27.9955 24.0594 28.2463 24.6364 28.683L22.5257 30.6211L20.5876 28.5103C21.1997 28.1243 21.9153 27.9337 22.639 27.9646Z"
        fill="#A7BBF7"
        stroke="#1434CB"
        strokeWidth={0.073656}
      />
      <Path
        d="M22.1531 19.8143C21.2727 18.8554 19.7817 18.7918 18.8229 19.6722C17.864 20.5526 17.8004 22.0436 18.6808 23.0025C19.5612 23.9613 21.0522 24.0249 22.0111 23.1446C22.9699 22.2642 23.0335 20.7731 22.1531 19.8143Z"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.3648 18.5199L22.5234 30.6731L29.4681 24.2967L18.3094 12.1435L11.3648 18.5199Z"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.5353 16.5274C13.9412 17.1539 14.1422 17.8912 14.1103 18.6371C14.0785 19.383 13.8155 20.1005 13.3577 20.6902"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.3025 14.3139C19.676 14.7198 18.9387 14.9208 18.1928 14.889C17.4469 14.8572 16.7294 14.5941 16.1397 14.1363"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.2979 26.2893C26.8919 25.6628 26.691 24.9254 26.7228 24.1796C26.7546 23.4337 27.0176 22.7162 27.4754 22.1265"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.5308 28.5029C21.1574 28.097 21.8947 27.896 22.6406 27.9278C23.3864 27.9596 24.1039 28.2227 24.6936 28.6805"
        stroke="#1434CB"
        strokeWidth={1.1785}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x={15.041}
        y={14.7629}
        width={9.69539}
        height={16.9669}
        transform="rotate(-21.2786 15.041 14.7629)"
        fill="#C6D4FF"
      />
      <Path
        opacity={0.2}
        d="M21.8381 18.7247C23.0783 18.2417 24.4753 18.8555 24.9584 20.0958C25.4414 21.336 24.8275 22.733 23.5873 23.216C22.347 23.699 20.95 23.0852 20.467 21.8449C19.984 20.6047 20.5978 19.2077 21.8381 18.7247Z"
        fill="black"
        stroke="#1434CB"
        strokeWidth={0.076507}
      />
      <Path
        opacity={0.2}
        d="M17.619 15.8959C17.3163 16.5847 16.8109 17.1645 16.1707 17.5584L15.0906 14.7849L17.8641 13.7047C18.007 14.4427 17.9217 15.2071 17.619 15.8959Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.076507}
      />
      <Path
        opacity={0.2}
        d="M23.0331 13.7871C22.3442 13.4844 21.7644 12.9791 21.3706 12.3388L24.1441 11.2587L25.2243 14.0322C24.4863 14.1751 23.7219 14.0898 23.0331 13.7871Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.076507}
      />
      <Path
        opacity={0.2}
        d="M30.3363 27.1566L27.5628 28.2368C27.4199 27.4988 27.5052 26.7344 27.8079 26.0456C28.1105 25.3567 28.6159 24.7769 29.2561 24.383L30.3363 27.1566Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.076507}
      />
      <Path
        opacity={0.2}
        d="M22.3933 28.1541C23.0821 28.4568 23.6619 28.9621 24.0558 29.6024L21.2823 30.6825L20.2021 27.909C20.9401 27.7661 21.7045 27.8514 22.3933 28.1541Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.076507}
      />
      <Path
        d="M24.994 20.0819C24.5033 18.8219 23.0841 18.1983 21.8242 18.689C20.5643 19.1797 19.9407 20.5989 20.4314 21.8588C20.922 23.1188 22.3412 23.7424 23.6011 23.2517C24.8611 22.761 25.4847 21.3418 24.994 20.0819Z"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.0412 14.7628L21.2605 30.7321L30.3858 27.1782L24.1665 11.2089L15.0412 14.7628Z"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.8927 13.6525C18.0494 14.412 17.966 15.2014 17.654 15.9113C17.3421 16.6212 16.817 17.2165 16.1516 17.6147"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M25.2765 14.0608C24.517 14.2175 23.7276 14.1341 23.0177 13.8222C22.3077 13.5102 21.7124 12.9851 21.3142 12.3197"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.5342 28.2889C27.3775 27.5295 27.4609 26.7401 27.7728 26.0302C28.0848 25.3202 28.6098 24.7249 29.2752 24.3267"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.1499 27.8804C20.9094 27.7237 21.6988 27.8071 22.4087 28.1191C23.1186 28.431 23.7139 28.9561 24.1121 29.6215"
        stroke="#1434CB"
        strokeWidth={1.22411}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x={20.5828}
        y={13.3729}
        width={9.83257}
        height={17.207}
        fill="#C6D4FF"
      />
      <Path
        opacity={0.2}
        d="M25.5483 19.619C26.8981 19.619 27.9924 20.7132 27.9924 22.063C27.9924 23.4129 26.8981 24.5071 25.5483 24.5071C24.1985 24.5071 23.1042 23.4129 23.1042 22.063C23.1042 20.7132 24.1985 19.619 25.5483 19.619Z"
        fill="#2D57D9"
        stroke="#1434CB"
        strokeWidth={0.0775895}
      />
      <Path
        opacity={0.2}
        d="M22.6021 15.3923C22.0625 15.9318 21.3715 16.2938 20.6216 16.4304V13.4118H23.6401C23.5036 14.1618 23.1416 14.8527 22.6021 15.3923Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.0775895}
      />
      <Path
        opacity={0.2}
        d="M28.4947 15.3923C27.9551 14.8527 27.5932 14.1618 27.4566 13.4118H30.4752V16.4304C29.7252 16.2938 29.0342 15.9318 28.4947 15.3923Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.0775895}
      />
      <Path
        opacity={0.2}
        d="M30.4752 30.7144H27.4566C27.5932 29.9644 27.9551 29.2734 28.4947 28.7339C29.0342 28.1943 29.7252 27.8324 30.4752 27.6958V30.7144Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.0775895}
      />
      <Path
        opacity={0.2}
        d="M22.6018 28.7339C23.1414 29.2734 23.5033 29.9644 23.6399 30.7144H20.6213V27.6958C21.3713 27.8324 22.0623 28.1943 22.6018 28.7339Z"
        fill="#244BBE"
        stroke="#1434CB"
        strokeWidth={0.0775895}
      />
      <Path
        d="M28.0312 22.063C28.0312 20.6918 26.9195 19.5802 25.5483 19.5802C24.177 19.5802 23.0654 20.6918 23.0654 22.063C23.0654 23.4343 24.177 24.5459 25.5483 24.5459C26.9195 24.5459 28.0312 23.4343 28.0312 22.063Z"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.5825 13.3731V30.7532H30.514V13.3731H20.5825Z"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M23.6863 13.373C23.5549 14.1483 23.1856 14.8636 22.6295 15.4197C22.0734 15.9758 21.3581 16.3451 20.5828 16.4766"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M30.514 16.4766C29.7386 16.3451 29.0233 15.9758 28.4672 15.4197C27.9112 14.8636 27.5418 14.1483 27.4104 13.373"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.4104 30.7532C27.5418 29.9778 27.9112 29.2625 28.4672 28.7064C29.0233 28.1504 29.7386 27.781 30.514 27.6496"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.5825 27.6496C21.3579 27.781 22.0732 28.1504 22.6293 28.7064C23.1853 29.2625 23.5547 29.9778 23.6861 30.7532"
        stroke="#1434CB"
        strokeWidth={1.24143}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_6725">
        <Rect
          width={24}
          height={24}
          fill="white"
          transform="matrix(0 -1 1 0 9 33)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
